import {
	Component,
	OnInit,
	Input,
	Output,
	EventEmitter,
	ViewChild,
	SimpleChange,
	ChangeDetectorRef,
	ElementRef,
} from "@angular/core";
import { NgForm } from "@angular/forms";
import _ from "lodash";
import { HelperService } from "@services/helper.service";
import { Paginator } from "primeng/paginator";

@Component({
	selector: "PagesEntryModal",
	templateUrl: "./PagesEntryModal.component.html",
	styleUrls: ["./PagesEntryModal.component.scss"],
})
export class PagesEntryModal implements OnInit {
	@Input() tableConfig;
	@Input() TABLE_CONFIG;
	@Input() showEntries = true;
	@Input() showLoadMore = false;
	@Input() fromLoadMore = false;
	@Input() keepScrollPosition = false;

	@Output() entriesChanged = new EventEmitter();
	// @Output() pageChanged = new EventEmitter();
	@Output() pageChanged = new EventEmitter<{
		page: number;
		callback: () => void;
	}>();

	@ViewChild("columnDisplayModal") localModal;
	@ViewChild("pagePaginator", { static: true }) paginator: Paginator;
	// @ViewChild("scrollContainer") scrollContainer!: ElementRef;

	lodash = _;
	initPageNumber = true;
	loading = false;

	constructor(
		private helperService: HelperService,
		private cdr: ChangeDetectorRef
	) {}

	ngOnInit() {}

	ngOnChanges() {
		if (this.initPageNumber && this.tableConfig.page != 1) {
			this.initPageNumber = false;
			this.updateCurrentPage(this.tableConfig.page - 1, true);
		}
	}

	changeEntry() {
		this.entriesChanged.emit(true);
	}

	changePage($event, emitEvent: boolean = true) {
		if (emitEvent) {
			this.pageChanged.emit($event);
		}
	}

	updateCurrentPage(currentPage: number, emitEvent: boolean = false): void {
		this.tableConfig.page = currentPage;

		setTimeout(() => this.paginator.changePage(currentPage));

		this.changePage({ page: currentPage }, emitEvent);
		// this.cdr.detectChanges();
	}

	loadMore() {
		if (this.loading) return;

		this.loading = true;
		const nextPage = this.tableConfig.page;

		this.pageChanged.emit({
			page: nextPage,
			callback: () => {
				console.log("Got callback...");
				setTimeout(() => {
					this.loading = false;
					this.cdr.detectChanges();
				}, 0);
				if (!this.fromLoadMore) this.updateCurrentPage(nextPage, false);
			},
		});
	}
}
